import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { DestroyAbleComponent } from '../destroyable/destroyable.component';

@Component({
  selector: 'un-form-array-tabs',
  templateUrl: './form-array-tabs.component.html',
  styleUrls: ['./form-array-tabs.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormArrayTabsComponent
  extends DestroyAbleComponent
  implements OnInit
{
  @Input() selectedIndex = 0;
  @Input() formArr: FormArray<FormGroup>;
  @Input() formTmp: TemplateRef<any>;
  @Input() tabTitle: string;
  @Input() tabTitleFn?: (index: number) => string;
  @Output() add = new EventEmitter<void>();

  @ContentChild(TemplateRef) tmpl: TemplateRef<any>;

  ngOnInit(): void {
    const { value = [] } = this.formArr;
    let index = value.length - 1;
    this.formArr &&
      this.formArr.valueChanges.pipe(takeUntil(this.dead$)).subscribe((v) => {
        if (v.length - 1 > index) {
          this.selectedIndex = v.length - 1;
          index++;
        } else index = v.length - 1;
      });
  }
  showClose(index: number) {
    return !this.formArr.at(index).hasValidator(Validators.required);
  }
}
